export default __webpack_public_path__ + "static/media/first.b7d3a8c1.svg";